import { CognitoUser } from '@aws-amplify/auth';
import { useUnit } from 'effector-react';
import { $queryParams } from 'models/location';
import navigate from 'models/router-gate';
import { Button, Card, Col, Form } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';

import './ResetPassword.scss';

import HookFormControl from 'components/HookFormControl';

import AuthService from 'services/AuthService';

import useResources from 'hooks/useResources';

import signin_page_image from 'assets/signin_page_image_big.png';
import signin_page_image_webp from 'assets/signin_page_image_big.webp';

type ResetPasswordProps = {
    user?: CognitoUser;
};

const ResetPassword = (props: ResetPasswordProps) => {
    const { user } = props;

    const { t } = useResources();
    const form = useForm();

    const { user_name, confirmation_code, role } = useUnit($queryParams);

    const onSubmit = async (data: any) => {
        if (data.password === data.passwordConfirmation) {
            let success;
            if (user) {
                success = await AuthService.respondToAuthChallenge(user, data.password);
            } else {
                success = await AuthService.forgotPasswordSubmit(user_name, confirmation_code, data?.password);
            }
            if (success) {
                navigate(role ? `/?role=${role}` : '/');
            }
        } else {
            form.setError('passwordConfirmation', { message: t('forgotPassword.new_password_confirmation_error') });
        }
    };

    return (
        <div className="row signup-row custom-sign-in">
            <div className="col-sm text-center form-holder font-weight-bold text-dark">
                <Card className="signup-row">
                    <h2 className="text-center font-weight-bold">{t('forgotPassword.reset_your_password')}</h2>
                    <FormProvider {...form}>
                        <Form onSubmit={form.handleSubmit(onSubmit)}>
                            <Form.Row>
                                <Form.Group as={Col}>
                                    <HookFormControl.Password
                                        name="password"
                                        label={t('forgotPassword.new_password')}
                                        withHint={true}
                                        rules={{
                                            required: t('forgotPassword.new_password_required'),
                                            minLength: {
                                                value: 8,
                                                message: t('forgotPassword.new_password_error'),
                                            },
                                        }}
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col}>
                                    <HookFormControl.Password
                                        name="passwordConfirmation"
                                        label={t('forgotPassword.new_password_confirmation')}
                                        withHint={true}
                                        rules={{
                                            required: t('forgotPassword.new_password_confirmation_error'),
                                            minLength: {
                                                value: 8,
                                                message: t('forgotPassword.new_password_error'),
                                            },
                                        }}
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Button data-qaid="submit_button" type="primary" variant="primary" className="mb-2" block>
                                {t('forgotPassword.submit')}
                            </Button>
                        </Form>
                    </FormProvider>
                </Card>
            </div>
            <div className="col-sm image-holder d-none d-lg-flex">
                <picture>
                    <source srcSet={signin_page_image_webp} type="image/webp" />
                    <img src={signin_page_image} className="img-fluid" alt="sign-in" />
                </picture>
            </div>
        </div>
    );
};

export default ResetPassword;
